import React, { useContext } from "react";
import useMediaQuery from "../../hooks/UseMediaQuery";
import { Link, createSearchParams, useLocation } from "react-router-dom";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";

function CampaignListing({ data, theme }) {
  const { setDetails } = useContext(Context);
  const { searchParams } = useUserAuth();
  const isDesktop = useMediaQuery("(min-width:640px)");
  const location = useLocation();
  const splitUrl = (url) => {
    if (url) {
      const urlParts = new URL(url);
      const pathname = urlParts.pathname;
      return pathname;
    }
  };
  return (
    <div className="max-w-[1440px] pb-20 mx-auto">
      <div
        className="fonts-for-Sathosi-campaigns "
        style={{ color: theme?.runningCampaignsMainColor }}
      >
        <div>
          <p className="ml-4 sm:ml-10 font-[700] text-[24px] uppercase">
            {" "}
            {data?.name}{" "}
          </p>
        </div>

        <div
          className={`${
            isDesktop
              ? "grid-cols-4 grid gap-[8px] "
              : "template-CampaignsListing-scroll flex gap-[20px] overflow-scroll px-[20px] py-[8px]"
          }  `}
        >
          {data?.datas?.map((item, index) => (
            <Link
              className="hover:text-black hover:no-underline drop-shadow-xl bg-white pb-[10px]"
              to={{
                pathname: `${
                  data?.secId !== "UpComing" && splitUrl(item?.link)
                }`,
                search: `${
                  searchParams ? createSearchParams(searchParams) : ""
                }`,
              }}
              state={{ previousLocation: location?.pathname }}
            >
              <div
                className="justify-center mt-8 items-start grid"
                onClick={() => setDetails([])}
              >
                <div className="justify-center  items-center flex">
                  <div className="xl:w-[283px] lg:w-[200px] w-[270px] h-[290px] sm:w-[160px] sm:h-[160px] lg:h-[200px] xl:h-[331px] relative">
                    <img
                      className="w-full h-full object-cover"
                      src={item?.image}
                      alt=""
                    />
                    {data?.secId !== "UpComing" && (
                      <div className="absolute bottom-0 left-0 right-0 top-[75%] justify-center items-center flex">
                        <button className="text-[16px] font-[500] bg-slate-100 px-3 py-2  rounded-lg text-[black]">
                          {" "}
                          View Contest
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                <div className="text-center ">
                  <div className=" sm:ml-6 ml-2 mr-2  sm:mr-6 drop-shadow-xl">
                    <p className="mt-2 text-[28px] sm:text-[18px] xl:text-[26px] font-[700] leading-[33px] ">
                      {" "}
                      {item?.name}{" "}
                    </p>

                    <p
                      style={{ color: theme?.textColor }}
                      className="text-[16px] mt-2 sm:text-[10px] xl:text-[16px] font-[400]"
                    >
                      {" "}
                      {item?.text?.slice(0, 70)}...
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CampaignListing;
